export default __webpack_public_path__ + "static/media/generalAccountChecklist.0178de2e.svg";